export type TimeValueType = 'allTime' | 'today' | 'last3days' | '7daysAgo' | '30daysAgo' | 'lasthour' | 'thisyear'

export default [
  { label: 'All time', value: 'allTime' },
  { label: 'Today', value: 'today' },
  { label: 'Last 3 days', value: 'last3days' },
  { label: 'Last 7 days ago', value: '7daysAgo' },
  { label: 'Last 30 days ago', value: '30daysAgo' },
] as { label: string; value: TimeValueType }[]
